import React from 'react';
import './section5.css'
import Title from '../common/title';
import Text from '../common/text';
import Sec5card from '../common/section5-card';
import Btn from '../common/btn';
import star from '../../asserts/star.png'

const Sec5 = () => {
    return ( <>
    <section className='sec5'>
        <article className='sec5-div'>
        <div className='sec5-v'>
             <Title title='Our Projects' t='title' />
            <Text text='At Golden Hills, our commitment to quality, innovation, and community is evident in every project we undertake. 
            From sprawling luxury homes to dynamic urban developments, we create spaces that meet the diverse needs of modern living. 
            Explore our portfolio to discover how we bring dreams to life, one project at a timeAt Golden Hills, our commitment to quality,
             innovation, and community is evident in every project we undertake. ' x='text'  />

              <img className='star' src={star} alt="" />
        </div>
        
        <div className='sec5-v'>
            
            <Sec5card sec5card='VILLAS' />
            <Sec5card sec5card='Apartments' />
            <Sec5card sec5card='Other Projects' />
                   
        
<Btn btn='Explore Now' />
        </div>


        </article>
        <div className='sec5-img'></div>

    </section>
    
    </> );
}
 
export default Sec5;